import avatar1 from '../../../../assets/images/xs/avatar1.jpg';
import avatar2 from '../../../../assets/images/xs/avatar2.jpg';
import avatar3 from '../../../../assets/images/xs/avatar3.jpg';
import avatar4 from '../../../../assets/images/xs/avatar4.jpg';
import avatar5 from '../../../../assets/images/xs/avatar5.jpg';
import avatar6 from '../../../../assets/images/xs/avatar6.jpg';


export const empAppraisalData = [
    {
        "name": "Andew Jon",
        "role": "Housekeeping Staff",
        "ratings": [
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star"}
        ],
        "comments": "Good Performer",
        "salary": "$28,000.00 Annually",
        "reviewer": "Manager",
        "empImg": avatar1
    },
    {
        "name": "Mitali Raj",
        "role": "Housekeeping Staff",
        "ratings": [
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"}
        ],
        "comments": "Good Performer",
        "salary": "$28,000.00 Annually",
        "reviewer": "Manager",
        "empImg": avatar2
    },
    {
        "name": "Jimmy Raj",
        "role": "Housekeeping Staff",
        "ratings": [
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"}
        ],
        "comments": "Good Performer",
        "salary": "$28,000.00 Annually",
        "reviewer": "Manager",
        "empImg": avatar3
    },
    {
        "name": "Viky Jon",
        "role": "Housekeeping Staff",
        "ratings": [
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"}
        ],
        "comments": "Good Performer",
        "salary": "$28,000.00 Annually",
        "reviewer": "Manager",
        "empImg": avatar4
    },
    {
        "name": "Riya Lee",
        "role": "Housekeeping Staff",
        "ratings": [
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"}
        ],
        "comments": "Good Performer",
        "salary": "$28,000.00 Annually",
        "reviewer": "Manager",
        "empImg": avatar5
    },
    {
        "name": "Perry Mal",
        "role": "Housekeeping Staff",
        "ratings": [
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"},
            {"star": "bi-star-fill"}
        ],
        "comments": "Good Performer",
        "salary": "$11,000.00 Annually",
        "reviewer": "Manager",
        "empImg": avatar6
    }
]
